import { createUseStyles } from 'react-jss'
import { WHITE } from '@omnilert/components'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  dropdownItem: {
    borderRadius: 'inherit !important',
    fontWeight: '600 !important',
    fontSize: '16px !important'
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    margin: '10px 0'
  },
  headerBody: {
    margin: '0 1%'
  },
  loader: {
    position: 'absolute',
    right: '15px',
    top: '0px'
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  toggleButton: {
    '--icon__primary__fill__color': WHITE,
    margin: '6px 8px'
  }
})

export default useStyles
